var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___RnMtU0",
  "S7": "ProfileCardUserInfo.module__nameRow___RnMtU0",
  "oo": "ProfileCardUserInfo.module__nameButton___RnMtU0",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___RnMtU0",
  "fC": "ProfileCardUserInfo.module__badgeContainer___RnMtU0",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___RnMtU0",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___RnMtU0",
  "Fj": "ProfileCardUserInfo.module__usernameRow___RnMtU0",
  "xO": "ProfileCardUserInfo.module__usernameButton___RnMtU0",
  "hI": "ProfileCardUserInfo.module__pronouns___RnMtU0",
  "sM": "ProfileCardUserInfo.module__srOnly___RnMtU0",
};

module.exports = exports;
